// import exportFromJSON from "export-from-json";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import React, { createContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector, shallowEqual } from "react-redux";
import { Api } from "../api";
const Context = createContext();

const defaultFilter = {
  MainElement: [],
  SubElement: [],
  Municipality: [],
  Street: [],
  Status: [],
  ReferralUnit: [],
  FlowStatus: [],
  Area: [],
  Severity: [],
  Campaign: [],
  CampaignType: [],
  PriorityType: [],
  PriorityArea: [],
  National: [],
  Initiative: [],
  Road: [],
  City: [],
  Date: [],
  IncidentId: [],
  DistrictPart: [],
  Month: [],
  SupervisionType: [],
  Auditor: [],
  Inspector: [],
  FinalElement: [],
  Activity: [],
  CheckListStatus: [],
}

const defaultDetectionQualityFilter = {
  priority_area: [],
  campaign: [],
  activity: [],
  Date: [],
  municipality: [],
  inspection: [],
}

const defaultAuditTableFilter = {
  SearchValue: '',
  StartRow: 1,
  Page: 0,
  Size: 10,
  SortColumn: '',
  SortOrder: 'ASC',
  Latitude: '',
  Longitude: ''
}

const today = new Date();
const yesterday = new Date(today.setDate(today.getDate() - 2))

const defaultTrackingFilter = {
  Municipality: [],
  Reporter: [],
  Dates: [], //[yesterday, new Date()]
  Speed: ''
}

const defaultSmartSupervisionFilter = {
  Municipality: [],
  Layer: [],
}

function AppContext({ children }) {
  const { t } = useTranslation();
  const auth = useSelector((state) => state.auth, shallowEqual);
  const { user } = auth;
  const [state, setState] = useState({
    selectedProgram: 1,
    searchText: "",
    trackingFilter: {
      ...defaultTrackingFilter
    },
    smartSupervisionFilter: {
      ...defaultSmartSupervisionFilter
    },
    auditTableFilter: {
      ...defaultAuditTableFilter
    },
    filterData: {
      ...defaultFilter,
      Campaign: ['المسار الأول', 'المسار الثاني'],
    },
    detectionQualityFilterData: {
      ...defaultDetectionQualityFilter,
    },
    filterFields: [
      {
        name: "Campaign",
        lookup: null
      },
      {
        name: "CampaignType",
        lookup: null
      },
      {
        name: "MainElement",
        lookup: null // "Campaign"
      },
      {
        name: "SubElement",
        lookup: null // "MainElement"
      },
      {
        name: "City",
        lookup: null
      },
      {
        name: "Municipality",
        lookup: null // "City"
      },
      {
        name: "Status",
        lookup: null
      }
    ],
    savedFilterTemplates: localStorage.getItem('filterTemplate') ? JSON.parse(localStorage.getItem('filterTemplate')) : [],
    selectedFilterTemplate: localStorage.getItem('selectedFilterTemplate') ? JSON.parse(localStorage.getItem('selectedFilterTemplate')) : null,
    mainMenuItems: [
      {
        name: "Home",
        href: "/web#menu_id=76&action=86",
      },
      {
        name: "Calender",
        href: "/web#menu_id=441&action=601",
      },
      {
        name: "Contractor Info",
        href: "/web#menu_id=503&action=700",
      },
      {
        name: "Overall Dashboard",
        href: "/web#menu_id=144&action=771",
      },
      {
        name: "Helpdesk",
        href: "/web#menu_id=189&action=",
      },
      {
        name: "Work Orders",
        href: "/web#menu_id=334&action=462",
      },
      {
        name: "Contractor Dashboard",
        href: "/web#menu_id=347&action=",
      },
      {
        name: "Supplier",
        href: "/web#menu_id=392&action=",
      },
      {
        name: "Summary Dashboard",
        href: "/web#menu_id=403&action=",
      },
      {
        name: "Purchases",
        href: "/web#menu_id=312&action=",
      },
      {
        name: "Invoice Submittal",
        href: "/web#menu_id=508&action=",
      },
      {
        name: "Project",
        href: "/web#menu_id=95&action=",
      },
      {
        name: "Events",
        href: "/web#menu_id=480&action=",
      },
      {
        name: "Discuss",
        href: "/web#menu_id=88&action=100",
      },
      {
        name: "WIM Stations",
        href: "/web#menu_id=580&action=",
      },
      {
        name: "RASED",
        href: "/web#menu_id=517&action=737",
      },
      {
        name: "Handover Reports",
        href: "/web#menu_id=505&action=714",
      },
      {
        name: "Website Admin",
        href: "/web#menu_id=77&action=",
      },
      {
        name: "Apps",
        href: "/web#menu_id=5&action=",
      },
      {
        name: "Settings",
        href: "/web#menu_id=4&action=",
      },
      {
        name: "DMS",
        href: "/web#menu_id=546&action=",
      },
    ],
  });

  const token = sessionStorage.getItem("s_id");

  useEffect(() => {

    const getFilterTemplates = async () => {
      try {
        const res = await Api.general.getDashboardFilters({
          token,
        })
        console.log(`getFilterTemplates: `, res.data.data)
      } catch (error) {
        console.log(error)
      }
    }

    token && getFilterTemplates()

  }, [])

  useEffect(() => {

    setState({
      ...state,
      filterData: {
        ...state.filterData,
        City: user.roles?.includes('Municipality') ? user.userCity : ['مدينة الرياض'],
        DistrictPart: user.roles?.includes('Municipality') ? user.userDistrictPart : [],
        Municipality: user.roles?.includes('Municipality') ? user.userMunicipality : [],
      }
    })
  }, [user])

  const saveFilterTemplates = async (data) => {
    console.log(`saveFilterTemplates: `, data);
    try {
      await Api.general.saveDashboardFilters({
        token,
        body: data,
      })
    } catch (error) {
      console.log(error)
    }
  }

  const setSelectedProgram = (value) => {
    setState({
      ...state,
      selectedProgram: value,
    });
  };

  const setFilterData = (data, resetFilterTemplate) => {


    let newData = {};
    if (!Array.isArray(data)) newData = data
    else data.map((item) => (newData[item.name] = item.value));
    setState({
      ...state,
      filterData: {
        ...state.filterData,
        ...newData,
      },
      selectedFilterTemplate: resetFilterTemplate ? null : state.selectedFilterTemplate
    });
  };

  const clearFilterData = () => {
    setState({
      ...state,
      filterData: {
        ...defaultFilter,
      },
      selectedFilterTemplate: null,
    });
  }

  const setDetectionQualityFilterData = (data, resetFilterTemplate) => {


    let newData = {};
    if (!Array.isArray(data)) newData = data
    else data.map((item) => (newData[item.name] = item.value));
    setState({
      ...state,
      detectionQualityFilterData: {
        ...state.detectionQualityFilterData,
        ...newData,
      },
      selectedFilterTemplate: resetFilterTemplate ? null : state.selectedFilterTemplate
    });
  };

  const clearDetectionQualityFilterData = () => {
    setState({
      ...state,
      detectionQualityFilterData: {
        ...defaultDetectionQualityFilter,
      },
      selectedFilterTemplate: null,
    });
  }

  const createFilterTemplate = () => {
    const oldData = state.savedFilterTemplates
    const newData = [...oldData, { name: `${t('Template')} #${oldData?.length + 1}`, filters: state.filterData }]
    localStorage.setItem('filterTemplate', JSON.stringify(newData));
    localStorage.setItem('selectedFilterTemplate', JSON.stringify(newData[newData.length - 1]));
    setState({
      ...state,
      savedFilterTemplates: newData,
      selectedFilterTemplate: newData[newData.length - 1]
    });
    // saveFilterTemplates(newData);
  }

  const renameFilterTemplate = (name, template) => {
    const newName = state.savedFilterTemplates.find(i => i.name === name) ? name + ' copy' : name;
    const newData = [...state.savedFilterTemplates.filter(i => i.name !== template.name), { name: newName, filters: template.filters }]
    if (state.selectedFilterTemplate?.name === template.name) {
      localStorage.setItem('filterTemplate', JSON.stringify(newData));
      localStorage.setItem('selectedFilterTemplate', JSON.stringify({ name: newName, filters: template.filters }));
      setState({
        ...state,
        savedFilterTemplates: newData,
        selectedFilterTemplate: { name: newName, filters: template.filters },
      });
      // saveFilterTemplates(newData);
    } else {
      localStorage.setItem('filterTemplate', JSON.stringify(newData));
      setState({
        ...state,
        savedFilterTemplates: newData,
      });
      // saveFilterTemplates(newData);
    }
  }

  const deleteFilterTemplate = (template) => {
    const newData = [...state.savedFilterTemplates.filter(i => i.name !== template.name)]
    if (state.selectedFilterTemplate?.name === template.name) {
      localStorage.setItem('filterTemplate', JSON.stringify(newData));
      localStorage.setItem('selectedFilterTemplate', JSON.stringify(null));
      setState({
        ...state,
        savedFilterTemplates: newData,
        selectedFilterTemplate: null,
      });
      // saveFilterTemplates(newData);
    } else {
      localStorage.setItem('filterTemplate', JSON.stringify(newData));
      setState({
        ...state,
        savedFilterTemplates: newData,
        selectedFilterTemplate: newData.length === 0 ? null : state.selectedFilterTemplate,
      });
      // saveFilterTemplates(newData);
    }
  }

  const setSelectedFilterTemplate = (filter) => {
    setState({
      ...state,
      selectedFilterTemplate: filter
    });
  }

  const setSearchText = (value) => {
    setState({
      ...state,
      searchText: value,
    });
  };

  const json2export = (data, name) => {
    if (data.length > 0) {
      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const fileExtension = ".xlsx";

      const exportToCSV = (csvData, fileName) => {
        const ws = XLSX.utils.json_to_sheet(csvData);
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };

        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: fileType });

        FileSaver.saveAs(data, fileName + fileExtension);
      };
      try {
        exportToCSV(data, name)
        // exportFromJSON({
        //   data: data,
        //   fileName: name,
        //   exportType: exportFromJSON.types.xls,
        // });
      } catch (error) {
        console.log(error);
      }
    }
  };

  const setTrackingFilter = (data) => {


    let newData = {};
    if (!Array.isArray(data)) newData = data
    else data.map((item) => (newData[item.name] = item.value));
    setState({
      ...state,
      trackingFilter: {
        ...state.trackingFilter,
        ...newData,
      },
    });
  };

  const clearTrackingFilter = () => {
    setState({
      ...state,
      trackingFilter: {
        ...defaultTrackingFilter,
      },
    });
  }

  const setSmartSupervisionFilter = (data) => {


    let newData = {};
    if (!Array.isArray(data)) newData = data
    else data.map((item) => (newData[item.name] = item.value));
    setState({
      ...state,
      smartSupervisionFilter: {
        ...state.smartSupervisionFilter,
        ...newData,
      },
    });
  };

  const clearSmartSupervisionFilter = () => {
    setState({
      ...state,
      smartSupervisionFilter: {
        ...defaultSmartSupervisionFilter,
      },
    });
  }

  const handleChangeAuditTablePage = (newPage) => {
    setState({
      ...state,
      auditTableFilter: {
        ...state.auditTableFilter,
        Page: newPage
      }
    })
  };

  const handleChangeAuditTableRowsPerPage = (value) => {
    setState({
      ...state,
      auditTableFilter: {
        ...state.auditTableFilter,
        Page: 0,
        Size: parseInt(value, 10),
      }
    })
  };

  const handleChangeAuditTableSearch = (value) => {
    setState({
      ...state,
      auditTableFilter: {
        ...state.auditTableFilter,
        Page: 0,
        SearchValue: value,
      }
    })
  };

  const appState = {
    ...state,
    setSelectedProgram,
    setFilterData,
    clearFilterData,
    setDetectionQualityFilterData,
    clearDetectionQualityFilterData,
    createFilterTemplate,
    setSelectedFilterTemplate,
    renameFilterTemplate,
    deleteFilterTemplate,
    setSearchText,
    json2export,
    handleChangeAuditTablePage,
    handleChangeAuditTableRowsPerPage,
    handleChangeAuditTableSearch,
    setTrackingFilter,
    clearTrackingFilter,
    setSmartSupervisionFilter,
    clearSmartSupervisionFilter,
  };

  return <Context.Provider value={appState}>{children}</Context.Provider>;
}

export default AppContext;
export { Context };
